import React from 'react';
import { FaDownload } from "react-icons/fa";
import './HomeOverlay.css';

const HomeOverlay = () => {
  const handleDownload = () => {
    if (window.fbq) {
      window.fbq('track', 'Lead', { content_name: 'Home Video Overlay', content_category: 'Mobile App' });
    }
    window.open("https://play.google.com/store/apps/details?id=com.astrobhagyap", "_blank");
  };

  return (
    <div className="home-mini-card">
        <div className="home-mini-header">
            <img src={require("../../assets/AstrobhagyaLogoo.webp")} alt="Logo" className="mini-logo" />
            <img src={require("../../assets/AstrobhagyaName.webp")} alt="Name" className="mini-name" />
        </div>
        <div className="home-mini-body">
          <h1 className="mini-title">Talk To Verified Astrologers</h1>
          <div className="mini-offer-box">
    <h2 className="mini-offertext " style={{ color: "#d4af37" }}>First Chat FREE!</h2>
    {/* <div className="promo-code-mini">ASTRO20</div> */}
          {/* <h1 className="mini-title">Guidance
           is in the Stars</h1>
          <div className="mini-offer-box">
    <h2 className="mini-offertext">Get Upto 20% OFF CODE</h2>
    <div className="promo-code-mini">ASTRO20</div> */}
  </div>  
          <button className="mini-download-btn" onClick={handleDownload}>
            <FaDownload /> DOWNLOAD NOW
          </button>
        </div>
    </div>
  );
};

export default HomeOverlay;